export default __webpack_public_path__ + "static/douglas1-fb627e11cc10d8ad304756c0a23e5410.png";